// R-2 guard. Source: docs/specs/sprint-3/stage-4-screens.md §3.2
//              + docs/specs/sprint-5/stage-4-frontend.md §6.5 (RF-S5-S4-22).
//
// Sprint 5 RF-S5-S4-22: decide-logика вынесена в pure helper `decideConsentRedirect`
// (mirror Sprint 4 RF-28 pattern). switch без default — TS exhaustiveness ловит
// забытые kind'ы. undefined обрабатывается отдельной веткой перед switch'ем.

import { Redirect } from 'wouter';
import type { ReactNode } from 'react';
import { useOnboardingState, type OnboardingState } from '@/hooks/useOnboardingState';
import { FullScreenSpinner } from '@/components/FullScreenSpinner';

/**
 * Pure decision helper. Возвращает redirect-target path или null (= render children).
 * Exported для §7 T-S5-15 unit-тестов.
 */
export function decideConsentRedirect(state: OnboardingState | undefined): string | null {
  if (!state) return '/signin';
  switch (state.kind) {
    case 'unauth':
      return '/signin';
    case 'verifyPending':
      return '/verify-code';
    case 'consentNeeded':
      return '/consent';
    case 'surveyPending':
    case 'surveyDone':
    case 'uploadAwaitingReview':
    case 'uploadConfirmed1':
    case 'uploadConfirmedMany':
    case 'dashboardError':
      return null;
  }
}

export function RequireConsent({ children }: { children: ReactNode }) {
  const { state, isLoading } = useOnboardingState();
  if (isLoading) return <FullScreenSpinner />;
  const target = decideConsentRedirect(state);
  if (target) return <Redirect to={target} />;
  return <>{children}</>;
}
